import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useQuote } from "../context/QuoteContext";
import "../styles/layout.css";

function AppLayout() {
  const { quote } = useQuote();
  return (
    <div className="appShell">
      <div className="appHeader"><Header quote={quote} /></div>
      <div className="appBody">
        <div className="appSidebar"><Sidebar /></div>
        <main className="appContent"><Outlet /></main>
      </div>
    </div>
  );
}
export default AppLayout;
